import { render, staticRenderFns } from "./GerenciaCadastroEstrutraPedagogica.vue?vue&type=template&id=4d9504a7"
import script from "./GerenciaCadastroEstrutraPedagogica.vue?vue&type=script&lang=js"
export * from "./GerenciaCadastroEstrutraPedagogica.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports